
import React, { useState, useEffect, useRef } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import '../../scss/Navmenudetail.scss'
import { TIME_REDCORE } from 'shared/app-settings';

export default function TimeRecord(props) {
    const { visible, indexCauHoi, indexNhom, onFinish, isSpeaking = false } = props;
    const [count, setCount] = useState(TIME_REDCORE[indexNhom] || 0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showFinishBtn, setShowFinishBtn] = useState(false);
    const intervalRef = useRef(null);
    const finishBtnTimerRef = useRef(null);
    const initialCount = TIME_REDCORE[indexNhom] || 0;

    useEffect(() => {
        if (visible) {
            const initCount = TIME_REDCORE[indexNhom] || 0;
            setCount(initCount);
            setShowFinishBtn(false);

            if (intervalRef.current) clearInterval(intervalRef.current);
            if (finishBtnTimerRef.current) clearTimeout(finishBtnTimerRef.current);

            finishBtnTimerRef.current = setTimeout(() => {
                setShowFinishBtn(true);
            }, 10000);

            intervalRef.current = setInterval(() => {
                setCount((data) => {
                    let newCount = data - 1;
                    if (newCount <= 0) {
                        if (intervalRef.current) {
                            clearInterval(intervalRef.current);
                            intervalRef.current = null;
                        }
                        // Dùng setTimeout để tránh lỗi "Cannot update a component while rendering"
                        // onFinish gọi setState của component cha nên phải đưa ra ngoài render cycle
                        setTimeout(() => onFinish(), 0);
                        return 0;
                    }
                    return newCount;
                })
            }, 1000);

            return () => {
                if (intervalRef.current) { clearInterval(intervalRef.current); intervalRef.current = null; }
                if (finishBtnTimerRef.current) { clearTimeout(finishBtnTimerRef.current); finishBtnTimerRef.current = null; }
            };
        } else {
            setCount(TIME_REDCORE[indexNhom] || 0);
            setShowFinishBtn(false);
            if (intervalRef.current) { clearInterval(intervalRef.current); intervalRef.current = null; }
            if (finishBtnTimerRef.current) { clearTimeout(finishBtnTimerRef.current); finishBtnTimerRef.current = null; }
        }
    }, [visible, indexNhom]);

    useEffect(() => {
        setCount(TIME_REDCORE[indexNhom] || 0);
    }, [indexNhom]);

    const onClickFinish = () => {
        onFinish();
    }

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Tính progress % cho vòng tròn
    const progress = initialCount > 0 ? (count / initialCount) : 0;
    const circleRadius = 80;
    const circumference = 2 * Math.PI * circleRadius;
    const strokeDashoffset = circumference * (1 - progress);

    const renderWaveform = () => {
        const totalBars = 60;
        const center = totalBars / 2;
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1.5,
                width: '100%',
                height: 56,
                padding: '0 8px',
                marginTop: 16,
            }}>
                {Array.from({ length: totalBars }, (_, i) => {
                    const distFromCenter = Math.abs(i - center) / center;
                    // Chiều cao khi đang nói: cao ở giữa, thấp 2 bên (hình thoi)
                    const activeH = 4 + (1 - distFromCenter) * 32;
                    // Chiều cao khi im lặng: rất nhỏ
                    const idleH = 3 + (1 - distFromCenter) * 3;
                    // Màu: đỏ/cam ở giữa, xám 2 bên
                    const isCenter = distFromCenter < 0.55;
                    const color = isCenter ? '#e74c3c' : '#9ca3af';
                    const delay = (i * 0.03) + (Math.sin(i * 0.8) * 0.1);

                    return (
                        <span
                            key={i}
                            style={{
                                width: 2.5,
                                minWidth: 2.5,
                                height: isSpeaking ? activeH : idleH,
                                borderRadius: 999,
                                background: isSpeaking ? color : '#d1d5db',
                                transformOrigin: 'center',
                                transition: 'height 0.15s ease, background 0.2s ease',
                                animation: isSpeaking
                                    ? `waveA 0.5s ease-in-out ${delay}s infinite alternate`
                                    : 'none',
                            }}
                        />
                    );
                })}
            </div>
        );
    };

    return (
        <div className="card">
            <Dialog
                visible={visible}
                position='top-right'
                closable={false}
                modal={false}
                showHeader={false}
                style={{
                    width: isMobile ? '80vw' : '20vw',
                    height: '90vh',
                    borderRadius: 16,
                    overflow: 'hidden',
                }}
                onHide={() => { }}
                draggable={false}
                resizable={false}
            >
                <div style={{
                    height: '100%',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '24px 12px 16px',
                }}>
                    {/* Title */}
                    <div style={{ textAlign: 'center', marginBottom: 24 }}>
                        <span style={{
                            fontSize: 22,
                            fontWeight: 700,
                            color: '#1e1b4b',
                            letterSpacing: '-0.3px',
                        }}>
                            Recording...
                        </span>
                    </div>

                    {/* Countdown circle với progress ring */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: 6,
                    }}>
                        <div style={{ position: 'relative', width: 180, height: 180 }}>
                            {/* SVG progress ring */}
                            <svg
                                width={180}
                                height={180}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    transform: 'rotate(-90deg)',
                                }}
                            >
                                {/* Background ring */}
                                <circle
                                    cx={90}
                                    cy={90}
                                    r={circleRadius}
                                    fill="none"
                                    stroke="#e5e7eb"
                                    strokeWidth={4}
                                />
                                {/* Progress ring */}
                                <circle
                                    cx={90}
                                    cy={90}
                                    r={circleRadius}
                                    fill="none"
                                    stroke="#23085a"
                                    strokeWidth={4}
                                    strokeLinecap="round"
                                    strokeDasharray={circumference}
                                    strokeDashoffset={strokeDashoffset}
                                    style={{
                                        transition: 'stroke-dashoffset 1s linear',
                                    }}
                                />
                            </svg>
                            {/* Countdown text */}
                            <div style={{
                                position: 'absolute',
                                inset: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <span style={{
                                    fontSize: 48,
                                    fontWeight: 700,
                                    color: '#1e1b4b',
                                    letterSpacing: '-1px',
                                }}>
                                    {count}s
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Waveform */}
                    {visible && renderWaveform()}

                    {/* Cảnh báo khi âm lượng micro thấp */}
                    {/* {!isSpeaking && (
                        <div style={{
                            textAlign: 'center',
                            marginTop: 12,
                            fontSize: 14,
                            color: '#6b7280',
                            fontWeight: 500,
                        }}>
                            Audio input too low
                        </div>
                    )} */}

                    <div style={{ flex: 1 }} />

                    {/* Finish Recording button */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '0 4px',
                    }}>
                        {showFinishBtn && (
                            <button
                                onClick={() => onClickFinish()}
                                style={{
                                    width: '100%',
                                    padding: '14px 0',
                                    background: '#23085a',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 10,
                                    fontSize: 15,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    letterSpacing: '0.2px',
                                    transition: 'background 0.2s',
                                }}
                                onMouseOver={(e) => e.target.style.background = '#2d0e72'}
                                onMouseOut={(e) => e.target.style.background = '#23085a'}
                            >
                                Finish Recording
                            </button>
                        )}
                    </div>
                </div>
            </Dialog>
        </div>
    )
}
